module.exports = __webpack_public_path__ + "static/media/24.17693c7a.jpg";